import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import cx from 'classnames';
import RCore from 'RCore';
import { green700, grey200, red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import Autorenew from 'material-ui/svg-icons/action/autorenew';
import { Link } from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
import config from 'cfg';
import SMStream from '../SMStream';
import styled from 'styled-components';

import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconShare from 'material-ui/svg-icons/social/share';

class EISMStream extends SMStream {
    renderToolbar() {
        return <h1>F1 Common</h1>;
    }

    loadSMWidgets = params => {
        let { gpId, year } = params;

        return Promise.resolve([
            {
                name: 'F1GrandPrixAnnounceSMWidget',
                props: {
                    'data-year': year,
                    'data-gpx-id': gpId
                },
                key: `f1-announce-${gpId}`
            },
            {
                name: 'F1SeasonCalendarSMWidget',
                props: {
                    'data-year': year
                },
                key: `f1-calendar-${gpId}`
            },

            {
                name: 'F1Standings',
                groupTitle: `Drivers standings`,
                groupKey: 'drivers',
                props: {
                    'data-year': year,
                    type: 'drivers'
                },
                key: `f1-standings-driver`
            },
            {
                name: 'F1Standings',
                groupTitle: `Constructor cup standings`,
                groupKey: 'teams',
                props: {
                    'data-year': year,
                    type: 'teams'
                },
                key: `f1-standings-team`
            }
        ]);
    };
}

export default EISMStream;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/streams/f1/F1SMStream.js
 **/